export const isFreeServicePrice = (price) => {
  if (price === '' || price == null) {
    return false;
  }

  const parsed = Number(price);
  return Number.isFinite(parsed) && parsed === 0;
};

export const normalizeFreeServiceUsageLimit = (price, usageLimit) => {
  if (!isFreeServicePrice(price) || usageLimit === '' || usageLimit == null) {
    return null;
  }

  const parsed = Number(usageLimit);
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
};

export const isCustomerBookableService = (service) => (
  Boolean(service) && !service.disabled && service.visibleToCustomers !== false
);
